var BlockView = require('views/block/base-block-view');

var CustomizationView = BlockView.extend({
  className: 'customization-filter-container',
  initialize: function() {
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    let key = this.model.get('key') || 'text-content-customization';
    let slug = this.model.get('slug');
    let customization;
    if(slug) {
      customization = EF.customizations.getByKeyAndSlug(key, slug);
    } else if(this.model.get('attr_key')) {
      if(EF.customizations.get(key)) {
        let attrValue = EF.customizations.get(key).get(this.model.get('attr_key'));
        let value = this.model.get('value');
        customization = attrValue === value || (attrValue instanceof Array && attrValue.includes(value));
      }
    } else {
      customization = EF.customizations.get(key);
    }
    this.model.set('isCustomized', Boolean(customization));
    let blocks = customization ? this.model.get('present').blocks : this.model.get('absent').blocks;
    this.renderNestedBlocks(`${this.model.get('cid')}-customization-blocks`, blocks);
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = CustomizationView;
